export const render = Symbol("render");
export const textContent = Symbol("textContent");
